// extracted by css-extract-rspack-plugin
export default {"codeBlockTextArea":"lVDyi","placeholder":"mEdna","borderRadius":"Z8_lf","closeButton":"lbaPU","contentWrapper":"AYERM","iconShrink":"ahNg1"};